import React from 'react'

export const InviteIcon: React.FC = () => (
  <svg width="40" height="40">
    <g fill="none" fillRule="evenodd">
      <rect width="40" height="40" fill="#F6F5F4" rx="16" />
      <path d="M10 8h24v24H10z" />
      <path
        fill="#AB9F94"
        fillRule="nonzero"
        d="M19 11c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm10 0a1 1 0 011 1v2h2a1 1 0 010 2h-2v2a1 1 0 01-2 0v-2h-2a1 1 0 010-2h2v-2a1 1 0 011-1zM10 28.2c.389-4.774 4.263-7.2 8.984-7.2 4.788 0 8.722 2.293 9.015 7.2.012.195 0 .8-.751.8H10.727c-.25 0-.747-.54-.726-.8z"
      />
    </g>
  </svg>
)
